import { TextField } from '@pankod/refine-antd'
import { TextFieldProps } from '@pankod/refine-antd/dist/components/fields/text'
import React from 'react'

const TextFieldWithEmpty = (
  props: Omit<TextFieldProps, 'value'> & {
    value?: React.ReactNode
    placeholder?: string
  },
) => {
  if (!!props.value) return <TextField {...props} value={props.value} />

  return (
    <TextField
      {...props}
      value={props.placeholder || 'Kosong'}
      disabled
      italic
    />
  )
}

export default TextFieldWithEmpty
